export default {
  getMenusList: "/menupermission/querypermission",
  addMenus: "/menupermission/insert",
  editMenus: "/menupermission/modify",
  deleteMenus: "/menupermission/delete",
}



// WEBPACK FOOTER //
// ./src/api/config/setMenus.js